import { AbstractControl } from "@angular/forms";

// standard email validation before BBB-539
// export const PATTERN_EMAIL = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$';
export const PATTERN_EMAIL = '^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$';

export function EmailValidator(control: AbstractControl) {
  let isValid = true;
  let pattern = new RegExp(PATTERN_EMAIL);
    if (control.value && control.value.length > 0) {
      isValid = pattern.test(control.value)
    }
    return isValid ? null : { 'email': true };
}